import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { loginRequest, msalConfig } from "./api/authConfig";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { AuthProvider } from "./context/auth.context";
import "./i18n";
import { SettingsProvider } from "./context";

// const msalInstance = new PublicClientApplication(msalConfig);

let accountId = "";

// function handleResponse(response: any) {
// 	if (response !== null) {
// 		accountId = response.account.homeAccountId;
// 		msalInstance.setActiveAccount(response.account);
// 	} else {
// 		// In case multiple accounts exist, you can select
// 		const currentAccounts = msalInstance.getAllAccounts();
// 		if (currentAccounts.length === 0) {
// 			// no accounts signed-in, attempt to sign a user in
// 			msalInstance
// 				.loginRedirect(loginRequest)
// 				.then(() => { })
// 				.catch(console.error);
// 		} else if (currentAccounts.length >= 1) {
// 			accountId = currentAccounts[0].homeAccountId;
// 			msalInstance.setActiveAccount(currentAccounts[0]);
// 		}
// 	}
// }

// msalInstance.handleRedirectPromise().then(handleResponse);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
	<SettingsProvider>
		<App />
	</SettingsProvider>
);

defineCustomElements(window);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
